import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastProvider } from "./common/toast/ToastContext";
import { AuthProvider } from "./user_module/context/AuthContext";

// ================= USER MODULE =================
import Homepage from './user_module/components/Homepage';
import UserForm from './user_module/components/UserForm';
import TimeTable from './user_module/components/time_table/TimeTable';
import RegisterPage from './user_module/components/login_and_registration/RegisterPage';
import LoginPage from './user_module/components/login_and_registration/LoginPage';
import FooterLinks from './user_module/components/FooterLinks';
import CombinedSection from './user_module/components/CombinedSection';
import PrivacyPolicy from './user_module/components/PrivacyPolicy';
import TermsAndConditions from './user_module/components/TermsAndConditions';
import RefundPolicy from './user_module/components/RefundPolicy';
import ShippingPolicy from './user_module/components/ShippingPolicy';
import ContactUs from './user_module/components/ContactUs';
import ProfilePage from './user_module/components/profile/ProfilePage';
import ClientPlansPage from './user_module/components/subscription_plans/ClientPlansPage';
import PrivateRoute from './user_module/components/PrivateRoute';
import MyActivePlanPage from './user_module/components/MyActivePlanPage';
import Faqs from "./user_module/components/faq/Faqs";
import HowDoesItWork from "./user_module/components/HowDoesItWork";
import GettingStarted from "./user_module/components/GettingStarted";
import ForgotPasswordPage from "./user_module/components/login_and_registration/ForgotPasswordPage";
import ResetPasswordPage from "./user_module/components/login_and_registration/ResetPasswordPage";
import Support from "./user_module/components/support/Support";
import TicketHistory from "./user_module/components/support/TicketHistory";
import TicketDetail from "./user_module/components/support/TicketDetail";
import ReviewsPage from "./user_module/components/review/ReviewsPage";
import CheckoutPage from "./user_module/components/subscription_plans/CheckoutPage";
import Account from "./user_module/components/profile/Account";
import AnnouncementBar from "./user_module/announcement/AnnouncementBar";
import ReferralPage from "./user_module/components/referral/ReferralPage";

// ================= ADMIN MODULE =================
import AdminLoginPage from "./auth/AdminLoginPage";
import AdminRoutes from "./admin_module/routes/AdminRoutes";
import EventListPage from "./user_module/components/event/EventListPage";
import BookingPage from "./user_module/components/event/BookingPage";
import MyBookingsPage from "./user_module/components/event/MyBookingsPage";

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
      <Router>
        <Routes>

          {/* ================= PUBLIC USER ROUTES ================= */}
          <Route path="/" element={<Homepage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/users" element={<UserForm />} />
          <Route path="/timetable" element={<TimeTable />} />
          <Route path="/footerLinks" element={<FooterLinks />} />
          <Route path="/combinedSection" element={<CombinedSection />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/cancellation-refund" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/plans" element={<ClientPlansPage />} />
          <Route path="/my-active-plan" element={<MyActivePlanPage />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/how-it-works" element={<HowDoesItWork />} />
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/support" element={<Support />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/support/tickets" element={<TicketHistory />} />
          <Route path="/support/tickets/:ticketId" element={<TicketDetail />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/checkout/:planId" element={<CheckoutPage />} />
          <Route path="/account" element={<Account />} />
          <Route path="/announcementBar" element={<AnnouncementBar />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/events" element={<EventListPage />} />
          <Route path="/booking/:eventId" element={<BookingPage />} />
            <Route path="/my-bookings" element={<MyBookingsPage />} />
          

          {/* ================= PROTECTED USER ROUTES ================= */}
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />

          {/* ================= ADMIN ROUTES ================= */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminRoutes />} />

        </Routes>
      </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
